<!--
 * @Author: zxf
 * @Date: 2022-08-05 11:50:24
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:47:30
 * @Description: 检测点信息管理
-->

<template>
  <div
    v-loading="loading"
    class="l-page--inner l-page--search"
  >
    <!-- 查询条件 Start -->
    <div
      class="l-page__item u-mg-b-10"
    >
      <!-- 查询条件表单 Start -->
      <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
      <el-form
        ref="filterParams"
        class="c-form c-condition__form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="85px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="8"
          >
            <el-form-item
              class="c-form__item"
              label="检测设备"
              prop="jcsbDm"
            >
              <select-sb
                v-model="filterParams.jcsbDm"
                clearable
                type="jc"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="6"
          >
            <el-form-item
              class="c-form__item"
              label="建筑物"
              prop="jzwId"
            >
              <el-select
                v-model="filterParams.jzwId"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择建筑物"
                @change="handleChange(filterParams.jzwId)"
              >
                <el-option
                  v-for="item in jzwOption"
                  :key="item.jzwId"
                  :value="item.jzwId"
                  :label="item.jzwmc"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="5"
          >
            <el-form-item
              class="c-form__item"
              label="楼层"
              prop="lcId"
              label-width="65px"
            >
              <el-select
                v-model="filterParams.lcId"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择楼层"
              >
                <el-option
                  v-for="(item,index) in lcOption"
                  :key="index"
                  :value="item"
                  :label="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="5"
          >
            <el-form-item
              class="c-form__item"
              label="检测结果"
              prop="jcjg"
            >
              <el-select
                v-model="filterParams.jcjg"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择检测结果"
              >
                <el-option
                  value="HG"
                  label="合格"
                />
                <el-option
                  value="BHG"
                  label="不合格"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            class="c-form__col u-mg-t-10 u-text-right"
            :span="24"
          >
            <k-button
              btn-text="查询"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            />
            <k-button
              btn-text="重置"
              :auth-type="false"
              icon="kestrel-icon ki-repeat"
              @click="resetForm()"
            />
          </el-col>
        </el-row>
      </el-form>
      <!-- 查询条件表单 End -->
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- table的ref的命名根据业务名称修改 -->
      <k-table
        ref="kTable"
        height="100%"
        :table-column="tableColumn"
        :data="page.rows"
        :pagination="page"
        @current-change="search"
        @size-change="handleSizeChange"
      >
        <template
          #jcdBh="scope"
        >
          <el-link
            type="primary"
            @click="handleDialog('view', {id: scope.row.jcdjlId})"
          >
            {{ scope.row.jcdBh }}
          </el-link>
        </template>
        <template
          #wczt="scope"
        >
          <span
            :class="{
              'u-text-success' : scope.row.jcjg==='HG',
              'u-text-danger' : scope.row.jcjg!=='HG'
            }"
          >
            {{ scope.row.jcjg === 'HG' ? '合格' : '不合格' }}
          </span>
        </template>
      </k-table>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 检测点信息查看 -->
    <jcd-view-dialog
      v-if="showDialogName==='view'"
      :dl-params="dialogParams"
      :xm-id="xmId"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { jcdService } from '../jcd/jcd.service';
import { jzwService } from '../jzw/jzw.service';
import JcdViewDialog from '../jcd/viewDialog.vue';

export default {
  name: 'JcdIndex',
  components: {
    JcdViewDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      xmId: null, // 检测项目ID
      jzwOption: [], // 建筑物选项
      lcOption: [], // 楼层选项
      // jcnrOption: [], // 检测内容选项

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 End */

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        jzwId: null, // 建筑物
        lcId: '', // 楼层
        jcsbDm: '', // 检测内容
        jcjg: null // 检测结果
      },
      JzwParams: {
        xmId: null

      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jcdBh', slotName: 'jcdBh', label: '检测点编号', align: 'left', width: '90', type: 'text' },
        { key: 'jcdMc', label: '设备名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jzwmc', label: '建筑或防火分区', align: 'left', minWidth: '120', type: 'text' },
        { key: 'lcId', label: '楼层', align: 'left', width: '130', type: 'text' },
        { key: 'jcdSl', label: '数量', align: 'center', width: '60', type: 'text' },
        { key: 'bz', label: '备注信息', align: 'left', minWidth: '150', type: 'text' },
        { key: 'wczt', slotName: 'wczt', label: '检测项完成状态', align: 'center', width: '110', type: 'text' },
        { key: 'cjsj', label: '录入时间', align: 'center', width: '130', type: 'dateTime' }
      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * 获取建筑物楼层数
     */
    handleChange (_var) {
      // 清空楼层数
      this.lcOption = [];
      // 清空楼层参数
      this.filterParams.lcId = null;
      this.jzwOption.forEach(item => {
        // 判断选择的建筑名称,获取建筑物的地上楼层数和地下楼层数
        if (item.jzwId === _var) {
          // 获取楼层数,从地下楼层一层层加入数组中
          for (let i = -item.dxcs; i <= item.dscs; i++) {
            // 0 表示没有,不用加入数组
            if (i !== 0) {
              this.lcOption.push(i + 'F');
            }
          }
          // 遍历结束退出最外层循环
          return '';
        }
      });
    },
    /**
     * @description: 获取查询条件选项
     * @return {*}
     */
    // getConditions () {
    //   jcdService.getJcdConditions(this.xmId)
    //     .then(rsp => {
    //       this.gwtJzwOptio();
    //       // this.lcOption = rsp.data.lcId;
    //       // this.jcnrOption = rsp.data.jcnr;
    //     })
    //     .catch(err => {
    //       console.error('获取查询条件选项信息失败！', err);
    //     });
    // },
    /**
     * 获取建筑楼层信息
     */
    gwtJzwOptio () {
      this.loading = true;
      console.log(this.xmId);
      this.JzwParams.xmId = this.xmId;
      jzwService.queryJzw(this.JzwParams)
        .then(rsp => {
          this.jzwOption = rsp.data.rows;
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;
      [this.trueFilterParams.jcnrId, this.trueFilterParams.jcdId] = this.trueFilterParams.jcsbDm.split('/');
      this.trueFilterParams.lcId = this.trueFilterParams.lcId ? this.trueFilterParams.lcId.split('F')[0] : '';
      jcdService.queryJcd(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
      this.lcOption = [];
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    this.gwtJzwOptio();
    this.refreshSearch();
  }
};
</script>

<style scoped>
  .o-form-btns{
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
</style>
